<template>
  <card>
    <apexchart
      type="pie"
      width="380"
      :options="platformInteractionChartOptions"
      :series="genderSeries"
    />
  </card>
</template>
<script>
export default {
  props: {
    headers: Array,
    series: Array
  },
  watch: {
    headers: {
      handler(data) {
        this.genderChartOptions = {
          xaxis: {
            categories: data
          }
        };
      },
      deep: true
    },
    series: {
      handler(d_ata) {
        this.genderSeries = d_ata || [0, 0];
      },
      deep: true
    }
  },
  data() {
    return {
      platformInteractionChartOptions: {
        tooltip: {
          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return parseFloat(value).toLocaleString();
            }
          }
        },
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: ["Facebook", "Instagram"],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      genderSeries: [0, 0]
    };
  }
};
</script>
